<div class="relative w-full h-full">
    @if (isMapEditToolbarActive() || mapTooltipService.isMapTooltipActive()) {
        <div class="absolute top-[2px] left-36 z-50 pointer-events-none">
            @if (mapEditModeService.isAddEntityModeActive()) {
                <app-label-badge
                    [baseIcon]="['fas', 'add']"
                    [canClose]="true"
                    [label]="'addEntityMode' | transloco"
                    (close)="leaveCreationMode()" />
            }

            @if (mapEditModeService.isGeographicEditModeActive()) {
                <app-label-badge
                    [baseIcon]="['far', 'draw-polygon']"
                    [label]="'editMode.geographic' | transloco"
                    [topIcon]="['fas', 'pen']" />
            }
        </div>
        @if (mapTooltipService.mapTooltip()) {
            <div class="absolute bottom-0 z-50 pointer-events-none add-line-vertex-text bg-on-primary p-2">
                <span>{{ mapTooltipService.mapTooltip() }}</span>
            </div>
        }
    }

    @if (mapModeService.isBboxShapingActive) {
        <div class="absolute top-[2px] left-36 z-50 pointer-events-none">
            <app-label-badge
                [baseIcon]="['far', 'draw-polygon']"
                [label]="'definitionProjectArea' | transloco"
                [topIcon]="['fas', 'pen']" />
        </div>

        <div class="absolute bottom-4 z-50 pointer-events-none add-line-vertex-text bg-on-primary p-2">
            <span>{{ 'clickToDefinProjectArea' | transloco }}</span>
        </div>
    }

    @if (selectionService.isFieldInterventionAreaMode()) {
        <div class="absolute top-[2px] left-36 z-50 pointer-events-none">
            <app-label-badge
                [baseIcon]="['far', 'draw-polygon']"
                [label]="'defineInterventionArea' | transloco"
                [topIcon]="['fas', 'pen']" />
        </div>

        <div
            class="absolute bottom-4 z-50 pointer-events-auto add-line-vertex-text bg-on-primary p-2"
            [matTooltip]="'fieldInterventionAreaDeviceCapacityWarning' | transloco">
            <span>{{ 'defineFieldInterventionAreaMessage' | transloco }}</span>
        </div>
    }

    <div
        #map
        class="absolute inset-0"></div>

    @if (mapModalService.hasAnyModalOpen()) {
        <app-map-modal />
    }

    <app-pin-panel />

    <div
        class="absolute inset-0 border-solid rounded-xl z-40 pointer-events-none"
        [class]="
            isMapEditToolbarActive() || mapModeService.isBboxShapingActive
                ? 'border-3 border-custom-blue'
                : 'border-2 border-outline-variant'
        "></div>

    <div class="relative">
        @if (hasProjects()) {
            <app-legend-button class="absolute top-2 left-2" />
        }
    </div>
    <app-map-scale-controller [backgroundSource]="backgroundSource()" />
</div>
